import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { useAppDispatch } from '../useStore';
import { changeCropTrendsListPageScrollY, setCropTrendsSelectedItem } from '../../../store/scrollYSlice';
import { resetCropTrendsAccordions, saveAccordionStates } from '../../../store/accordionSlice';

export const useCropTrendsScrollSave = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const previousPathRef = useRef<string>('');

  useEffect(() => {
    const handleScroll = () => {
      const { scrollY } = window;
      dispatch(changeCropTrendsListPageScrollY(scrollY));
    };

    // 농산물시세 페이지에서만 스크롤 이벤트 리스너 추가
    if (pathname === pageInfo.cropTrendsListPage.path) {
      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    return (): void => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pathname, dispatch]);

  // 페이지 이동 감지하여 다른 페이지로 이동할 때 상태 리셋
  useEffect(() => {
    const isCropTrendsPage =
      pathname === pageInfo.cropTrendsListPage.path || pathname === pageInfo.cropTrendsDetailPage.path;
    const wasCropTrendsPage =
      previousPathRef.current === pageInfo.cropTrendsListPage.path ||
      previousPathRef.current === pageInfo.cropTrendsDetailPage.path;

    // 이전에 농산물시세 페이지였고, 현재는 다른 페이지인 경우 상태 리셋
    if (wasCropTrendsPage && !isCropTrendsPage) {
      dispatch(changeCropTrendsListPageScrollY(0));
      dispatch(setCropTrendsSelectedItem(null));
      dispatch(resetCropTrendsAccordions());
    } else if (isCropTrendsPage && !wasCropTrendsPage) {
      // 농산물시세 페이지로 진입할 때 아코디언 상태 저장
      dispatch(saveAccordionStates());
    }

    previousPathRef.current = pathname;
  }, [pathname, dispatch]);
};
